import { render } from "./individual_tooth_chart_input.vue?vue&type=template&id=3e524e34&scoped=true"
import script from "./individual_tooth_chart_input.vue?vue&type=script&lang=js"
export * from "./individual_tooth_chart_input.vue?vue&type=script&lang=js"

import "./individual_tooth_chart_input.vue?vue&type=style&index=0&id=3e524e34&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e524e34"]])

export default __exports__